import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "changelog"
    }}>{`Changelog`}</h1>
    <h2 {...{
      "id": "indesign-v200"
    }}>{`InDesign v20.0`}</h2>
    <h4 {...{
      "id": "new"
    }}>{`New`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/src/pages/resources/recipes/flyout-menu/index.md"
        }}>{`Flyout Menus Support`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/src/pages/resources/recipes/persistent-storage-migration/index.md"
        }}>{`Peristent Storage Migration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/uxp/User%20Information/"
        }}>{`GUID support`}</a>{` `}</li>
    </ul>
    <h3 {...{
      "id": "uxp-v801"
    }}>{`UXP v8.0.1`}</h3>
    <h4 {...{
      "id": "breaking-changes"
    }}>{`Breaking Changes`}</h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`enableFillAsCustomAttribute`}</inlineCode>{` feature flag, introduced in UXP v7.1.0, will be turned on by default.`}</li>
    </ul>
    <h4 {...{
      "id": "deprecations"
    }}>{`Deprecations`}</h4>
    <ul>
      <li parentName="ul">{`Changes to Clipboard`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#setcontentdata"
            }}>{`Clipboard.setContent`}</a>{` is deprecated. Please use `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#writedata"
            }}>{`Clipboard.write`}</a>{` instead.`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#getcontent"
            }}>{`Clipboard.getContent`}</a>{` is deprecated. Please use `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#read"
            }}>{`Clipboard.read`}</a>{` instead.`}</li>
          <li parentName="ul">{`Passing an `}<inlineCode parentName="li">{`object`}</inlineCode>{` to `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md##writetexttext"
            }}>{`Clipboard.writeText(object)`}</a>{` is deprecated. Please use `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#writedata"
            }}>{`Clipboard.write(object)`}</a>{` instead.`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#clearcontent"
            }}>{`Clipboard.clearContent`}</a>{` is deprecated. `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#writetexttext"
            }}>{`Clipboard.writeText("")`}</a>{` would be an alternative.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Changes to VideoElement`}
        <ul parentName="li">
          <li parentName="ul">{`Event `}<inlineCode parentName="li">{`uxpvideoload`}</inlineCode>{` in `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement.md#load"
            }}>{`load()`}</a>{` is deprecated. Use `}<inlineCode parentName="li">{`loadeddata`}</inlineCode>{` instead.`}</li>
          <li parentName="ul">{`Event `}<inlineCode parentName="li">{`uxpvideoplay`}</inlineCode>{` in `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement.md#play"
            }}>{`play()`}</a>{` is deprecated. Use `}<inlineCode parentName="li">{`ended`}</inlineCode>{` instead.`}</li>
          <li parentName="ul">{`Event `}<inlineCode parentName="li">{`uxpvideocomplete`}</inlineCode>{` in `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement.md#play"
            }}>{`play()`}</a>{` is deprecated. Use `}<inlineCode parentName="li">{`ended`}</inlineCode>{` instead.`}</li>
          <li parentName="ul">{`Event `}<inlineCode parentName="li">{`uxpvideopause`}</inlineCode>{` in `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement.md#pause"
            }}>{`pause()`}</a>{` is deprecated. Use `}<inlineCode parentName="li">{`pause`}</inlineCode>{` instead.`}</li>
        </ul>
      </li>
    </ul>
    <h4 {...{
      "id": "new-1"
    }}>{`New`}</h4>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`New components supported in Spectrum Web Components (SWC). More details `}<a parentName="p" {...{
            "href": "https://github.com/adobe/swc-uxp-wrappers/tree/main?tab=readme-ov-file#spectrum-web-components-uxp-wrappers"
          }}>{`here`}</a></p>
        <ul parentName="li">
          <li parentName="ul">{`sp-asset`}</li>
          <li parentName="ul">{`sp-meter`}</li>
          <li parentName="ul">{`sp-number-field`}</li>
          <li parentName="ul">{`sp-overlay`}</li>
          <li parentName="ul">{`sp-quick-actions`}</li>
          <li parentName="ul">{`sp-search`}</li>
          <li parentName="ul">{`sp-swatch`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New command line templates to get started with SWC easily. Find details in this `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-spectrum/swc/index.md#command-line-templates"
          }}>{`section`}</a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Support for local HTML files in `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLWebViewElement.md#load-local-content-onto-webview"
          }}>{`WebView`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New CSS capabilities`}</p>
        <ul parentName="li">
          <li parentName="ul">{`scaleX() & scaleY()`}</li>
          <li parentName="ul">{`transform-origin`}</li>
          <li parentName="ul">{`translate property`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`Box-shadow`}</inlineCode>{` property now supports `}<inlineCode parentName="li">{`transform rotate`}</inlineCode>{`.`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`New feature flag `}<inlineCode parentName="p">{`CSSNextSupport`}</inlineCode>{` in the manifest.json to gate the new and future CSS capability.`}</p>
        <table parentName="li">
          <thead parentName="table">
            <tr parentName="thead">
              <th parentName="tr" {...{
                "align": null
              }}>{`Manifest setting`}</th>
              <th parentName="tr" {...{
                "align": null
              }}>{`Description`}</th>
            </tr>
          </thead>
          <tbody parentName="table">
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`featureFlags: {"CSSNextSupport": true}`}</inlineCode></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Enables all the new CSS features.`}</td>
            </tr>
            <tr parentName="tbody">
              <td parentName="tr" {...{
                "align": null
              }}><inlineCode parentName="td">{`featureFlags: {"CSSNextSupport": ["boxShadow", "transformFunctions", "transformProperties" ]}`}</inlineCode></td>
              <td parentName="tr" {...{
                "align": null
              }}>{`Enables only the named properties in the list.`}</td>
            </tr>
          </tbody>
        </table>
        <p parentName="li">{`Note that `}<inlineCode parentName="p">{`"enableSWCSupport": true`}</inlineCode>{` will enable `}<inlineCode parentName="p">{`CSSNextSupport`}</inlineCode>{` by default, even if it is not done explicitly in plugin manifest otherwise.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Video enhancements: Support added for `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement.md"
          }}>{`Seek Event`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Support for `}<a parentName="p" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/API/Navigator/language"
          }}>{`Navigator.language`}</a>{` API`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Support for new HTMLElement APIs - `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLElement.md#appendnodes"
          }}>{`append`}</a>{`, `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLElement.md#prependnodes"
          }}>{`prepend`}</a>{` and `}<a parentName="p" {...{
            "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLElement.md#replacechildrennodes"
          }}>{`replaceChildren`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`[Beta]`}{` Support for form reset in `}<a parentName="p" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form"
          }}>{`HTMLFormElement`}</a></p>
      </li>
    </ul>
    <h4 {...{
      "id": "updated"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul">{`Upgraded Spectrum Web Components to v0.37.0. `}<a parentName="li" {...{
          "href": "https://github.com/adobe/swc-uxp-wrappers/tree/main?tab=readme-ov-file#spectrum-web-components-uxp-wrappers"
        }}>{`More detail`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Clipboard.md#writetexttext"
        }}>{`UXP Clipboard.writeText()`}</a>{` now accepts strings as input to meet standards`}</li>
    </ul>
    <h2 {...{
      "id": "indesign-v194"
    }}>{`InDesign v19.4`}</h2>
    <h3 {...{
      "id": "uxp-v740"
    }}>{`UXP v7.4.0`}</h3>
    <h4 {...{
      "id": "updated-1"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul">{`UXP Alerts (`}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/alert.md"
        }}>{`alert`}</a>{`, `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/prompt.md"
        }}>{`prompt`}</a>{`, `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/confirm.md"
        }}>{`confirm`}</a>{`) have been moved back to beta due to a few inherent instabilities in this feature. While we work on addressing these issues, the feature can be accessed using the feature flag `}<inlineCode parentName="li">{`enableAlerts`}</inlineCode>{` in the manifest.json file. Also, note that UXP alerts will be `}<inlineCode parentName="li">{`available only in Plugins`}</inlineCode>{` and `}<inlineCode parentName="li">{`not in scripts`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Wildcards (*) at the top-level `}<inlineCode parentName="li">{`domain`}</inlineCode>{` name are not allowed. Please ensure you revisit the `}<inlineCode parentName="li">{`permissions`}</inlineCode>{` setup in manifest.json for `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLWebViewElement.md"
        }}>{`WebView`}</a>{`, and network calls `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/XMLHttpRequest.md"
        }}>{`XMLHttp`}</a>{` `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/fetch.md"
        }}>{`fetch`}</a></li>
      <li parentName="ul">{`New doc for tracking the `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-spectrum/spectrum-widgets-to-swc-mapping/index.md"
        }}>{`mapping between Spectrum widgets and Spectrum Web Components`}</a>{` in UXP`}</li>
    </ul>
    <h4 {...{
      "id": "fixed"
    }}>{`Fixed`}</h4>
    <ul>
      <li parentName="ul">{`XMP in Scripts.`}</li>
      <li parentName="ul">{`Plugin crashes while using `}<a parentName="li" {...{
          "href": "https://forums.creativeclouddeveloper.com/t/ps-2024-crashes-when-opening-my-uxp-plugin/6840/7"
        }}>{`fit-content`}</a>{` `}</li>
      <li parentName="ul">{`WebView support for `}<a parentName="li" {...{
          "href": "https://forums.creativeclouddeveloper.com/t/macos-uxp-webview-for-photoshop-is-missing-file-selector/6843"
        }}>{`file selector`}</a>{` in MacOS`}</li>
      <li parentName="ul">{`GUID returning hashed empty string`}</li>
      <li parentName="ul">{`Updated missing docs for pseudo-class `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-css/Pseudo-classes/defined.md"
        }}>{`defined`}</a>{` (Available since UXP v6.0)`}</li>
    </ul>
    <h2 {...{
      "id": "indesign-v192"
    }}>{`InDesign v19.2`}</h2>
    <h4 {...{
      "id": "updated-2"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`[BREAKING CHANGE]`}</strong>{` UXP logs and console.log `}<a parentName="li" {...{
          "href": "/indesign/uxp/scripts/tutorials/debug/"
        }}>{`paths`}</a>{` have changed.`}</li>
    </ul>
    <h2 {...{
      "id": "indesign-v190"
    }}>{`InDesign v19.0`}</h2>
    <p>{`Plug-Ins menu lists the installed UXP plugins and their panel entrypoints.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "392px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/57111f7b14f0568a328f0be4db3f3c2c/5530d/PluginsMenu.webp 320w", "/indesign/uxp/static/57111f7b14f0568a328f0be4db3f3c2c/480c8/PluginsMenu.webp 392w"],
            "sizes": "(max-width: 392px) 100vw, 392px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/indesign/uxp/static/57111f7b14f0568a328f0be4db3f3c2c/dd4a7/PluginsMenu.png 320w", "/indesign/uxp/static/57111f7b14f0568a328f0be4db3f3c2c/c4bf7/PluginsMenu.png 392w"],
            "sizes": "(max-width: 392px) 100vw, 392px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/indesign/uxp/static/57111f7b14f0568a328f0be4db3f3c2c/c4bf7/PluginsMenu.png",
            "alt": "Plug-Ins Menu",
            "title": "Plug-Ins Menu",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "fixed-1"
    }}>{`Fixed`}</h4>
    <ul>
      <li parentName="ul">{`Random app hang issue when invoking `}<inlineCode parentName="li">{`doScript()`}</inlineCode>{` from UXP plugins.`}</li>
      <li parentName="ul">{`App crashes at quit when event handlers are registered.`}</li>
    </ul>
    <h3 {...{
      "id": "uxp-v730--uxp-v72"
    }}>{`UXP v7.3.0 & UXP v7.2`}</h3>
    <h4 {...{
      "id": "new-2"
    }}>{`New`}</h4>
    <ul>
      <li parentName="ul">{`Multipart `}<inlineCode parentName="li">{`FormData`}</inlineCode>{` support in `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Request/"
        }}>{`Request`}</a>{` and `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/Response/"
        }}>{`Response`}</a>{` for `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/fetch/"
        }}>{`fetch`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/FormData/"
        }}>{`FormData`}</a>{` now supports the following APIs`}
        <ul parentName="li">
          <li parentName="ul">{`delete()`}</li>
          <li parentName="ul">{`get()`}</li>
          <li parentName="ul">{`getAll()`}</li>
          <li parentName="ul">{`has()`}</li>
          <li parentName="ul">{`keys()`}</li>
          <li parentName="ul">{`set()`}</li>
          <li parentName="ul">{`values()`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <b>(Photoshop Only)</b> GUID for uniquely identifying a Creative Cloud User.
      </li>
      <li parentName="ul">
        <b>(Photoshop Only)</b> Adobe Extensibility Metadata Platform (XMP) support.
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events"
        }}>{`pointer-events: none`}</a>{` `}<inlineCode parentName="li">{`CSS`}</inlineCode>{` property`}</li>
      <li parentName="ul">{`Support for `}<inlineCode parentName="li">{`pseudoElement`}</inlineCode>{` in `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/getComputedStyle"
        }}>{`getComputedStyle(element, pseudoElement)`}</a>{` API`}</li>
    </ul>
    <h4 {...{
      "id": "updated-3"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Data%20Transfers/FormData.md#append--namevaluefilename"
        }}>{`FormData's append`}</a>{` now supports `}<inlineCode parentName="li">{`Blob`}</inlineCode>{` as an additional parameter.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-spectrum/swc/"
        }}>{`Spectrum Web Component (SWC)`}</a>{` in UXP is moving out of Beta. `}
        <ul parentName="li">
          <li parentName="ul">{`Additional `}<a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-spectrum/swc/index.md#list-of-supported-swc"
            }}>{`components and variants`}</a></li>
          <li parentName="ul"><inlineCode parentName="li">{`Spectrum Web Components`}</inlineCode>{` support in `}<inlineCode parentName="li">{`React`}</inlineCode>{` context is now available for all 30 components.`}</li>
          <li parentName="ul">{`Starter plugins for `}<a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-indesign-samples/tree/main/plugins/swc-uxp-starter"
            }}>{`Spectrum Web Component`}</a>{` and `}<a parentName="li" {...{
              "href": "https://github.com/AdobeDocs/uxp-indesign-samples/tree/main/plugins/swc-uxp-react-starter"
            }}>{`Spectrum Web Component in React context`}</a></li>
        </ul>
      </li>
    </ul>
    <h4 {...{
      "id": "fixed-2"
    }}>{`Fixed`}</h4>
    <ul>
      <li parentName="ul">{`Tab Navigation not working for several SWC Components is now fixed`}</li>
      <li parentName="ul">{`Spacebar doesn't work on SWC Button component when reached via TAB navigation.`}</li>
      <li parentName="ul">{`Support for `}<inlineCode parentName="li">{`Alerts`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/alert/"
            }}>{`alert()`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/prompt/"
            }}>{`prompt()`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/confirm/"
            }}>{`confirm()`}</a></li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "udt-v20"
    }}>{`UDT v2.0`}</h3>
    <h4 {...{
      "id": "new-3"
    }}>{`New`}</h4>
    <ul>
      <li parentName="ul">{`UXP Playground to experiment with APIs. Click on the 'Playground' tab next to 'Developer Workspace' to select an app and get started.`}</li>
    </ul>
    <h4 {...{
      "id": "updated-4"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul">{`Plugin actions are surfaced based on the 'Status' of your plugin in the Developer Workspace`}</li>
    </ul>
    <h2 {...{
      "id": "indesign-v185"
    }}>{`InDesign v18.5`}</h2>
    <p>{`UXP Plugins are now available! Get started `}<a parentName="p" {...{
        "href": "../plugins"
      }}>{`here`}</a>{`.`}</p>
    <h3 {...{
      "id": "uxp-v71"
    }}>{`UXP v7.1`}</h3>
    <h4 {...{
      "id": "new-4"
    }}>{`New`}</h4>
    <p>{`HTMLElement now supports`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#setpointercapturepointerid"
        }}>{`setPointerCapture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#releasepointercapturepointerid"
        }}>{`releasePointerCapture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#haspointercapturepointerid"
        }}>{`hasPointerCapture`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLHtmlElement#dir--string"
        }}>{`dir`}</a></li>
    </ul>
    <h4 {...{
      "id": "updated-5"
    }}>{`Updated`}</h4>
    <ul>
      <li parentName="ul">{`Documentation for `}<inlineCode parentName="li">{`shell`}</inlineCode>{` moved to `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/uxp/shell/"
        }}>{`new location`}</a></li>
    </ul>
    <h4 {...{
      "id": "fixed-3"
    }}>{`Fixed`}</h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`SVGElement`}</inlineCode>{`: The color of the `}<inlineCode parentName="li">{`fill`}</inlineCode>{` attribute using a CSS variable will resolve as per the variable value. For now, please test this fix by enabling the feature flag in your plugin manifest `}<inlineCode parentName="li">{`"featureFlags" : { "enableFillAsCustomAttribute" : true }`}</inlineCode>{`. This flag will be turned on by default in the next UXP release. `}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`// CSS variable
html {
  --iconColor: yellow;
}

<svg height="100" width="100">
  <circle cx="50" cy="50" r="40" stroke="black" stroke-width="3" fill="var(--iconColor, red)" />
</svg>
// shows a yellow circle
`}</code></pre>
    <h3 {...{
      "id": "uxp-v70"
    }}>{`UXP v7.0`}</h3>
    <h4 {...{
      "id": "new-5"
    }}>{`New`}</h4>
    <ul>
      <li parentName="ul">{`Support for Web Components in UXP Plugins. Various HTML elements and methods have been added to support this feature.`}
        <ul parentName="li">
          <li parentName="ul">{`Classes`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLSlotElement/"
                }}>{`HTMLSlotElement`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLTemplateElement/"
                }}>{`HTMLTemplateElement`}</a></li>
            </ul>
          </li>
          <li parentName="ul">{`Methods`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element.md#assignedslot--htmlslotelement"
                }}>{`Element.assignedSlot`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#slot--string"
                }}>{`Element.slot`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#attachshadowinit"
                }}>{`Element.attachShadow`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#shadowroot--shadowroot"
                }}>{`Element.shadowRoot`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/CustomElementRegistry#upgraderoot"
                }}>{`CustomElementRegistry.upgrade`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/CustomElementRegistry#whendefinedname"
                }}>{`CustomElementRegistry.whenDefined`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/indesign/uxp/reference-spectrum/swc/"
        }}>{`Spectrum Web Components (Beta)`}</a>{` Support for Adobe SWC.`}</li>
      <li parentName="ul">{`Several augmentations to the JS API set`}
        <ul parentName="li">
          <li parentName="ul">{`Properties`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLElement#lang--string"
                }}>{`HTMLElement.lang`}</a></li>
            </ul>
          </li>
          <li parentName="ul">{`Classes added to the global scope`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/TreeWalker/"
                }}>{`TreeWalker`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/NodeFilter/"
                }}>{`NodeFilter`}</a></li>
            </ul>
          </li>
          <li parentName="ul">{`Methods`}
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#hasattributes"
                }}>{`Element.hasAttributes`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/Element#getattributenames"
                }}>{`Element.getAttributeNames`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Events/Event#composed--boolean"
                }}>{`Event.composed`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Events/Event#composedpath"
                }}>{`Event.composedPath`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/DocumentFragment#appendargs"
                }}>{`DocumentFragment.append`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/DocumentFragment#queryselectorselector"
                }}>{`DocumentFragment.querySelector`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/DocumentFragment#queryselectorallselector"
                }}>{`DocumentFragment.querySelectorAll`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul">{`New focus events to support React 16`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/focusin_event"
            }}>{`Focusin Event`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/focusout_event"
            }}>{`Focusout Event`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`HTML `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLCanvasElement/"
        }}>{`2D Canvas Support`}</a>{` for basic shapes and styling.`}</li>
      <li parentName="ul">{`Alerts`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/alert/"
            }}>{`alert()`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/prompt/"
            }}>{`prompt()`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20DOM/confirm/"
            }}>{`confirm()`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`Support for `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Streams/ReadableStream#pipeThroughtransform-options"
        }}>{`pipeThrough`}</a>{` and `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Streams/ReadableStream#tee"
        }}>{`tee`}</a>{` in `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Streams/ReadableStream"
        }}>{`ReadableStream`}</a>{`. Refer to `}<a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/Streams/"
        }}>{`Streams`}</a>{` for more details`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/ImageBlob/"
        }}>{`ImageBlob`}</a>{` to render an uncompressed image buffer in UXP`}</li>
    </ul>
    <h4 {...{
      "id": "changed"
    }}>{`Changed`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Global%20Members/HTML%20Elements/HTMLVideoElement/"
        }}>{`HTMLVideoElement`}</a>{`: 'metadata' is the default value for `}<inlineCode parentName="li">{`preload`}</inlineCode>{` attribute`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/indesign/uxp/indesign/uxp/reference/uxp-api/reference-js/Modules/fs/"
        }}>{`FS API`}</a>{`: No need for the `}<inlineCode parentName="li">{`file://`}</inlineCode>{` protocol`}</li>
    </ul>
    <h2 {...{
      "id": "indesign-v184"
    }}>{`InDesign v18.4`}</h2>
    <h3 {...{
      "id": "indesign-apis"
    }}>{`InDesign APIs`}</h3>
    <h4 {...{
      "id": "added"
    }}>{`Added`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`[BREAKING CHANGE]`}</strong>{` Mounting APIs `}<br></br>{`
InDesign DOM APIs are no longer available in the global scope. You must `}<a parentName="li" {...{
          "href": "../recipes/dom-versioning/"
        }}>{`mount the APIs`}</a>{` first before using them. Plus, you can now access different versions of DOM APIs.`}</li>
      <li parentName="ul">{`Events `}<br></br>{`
UXP scripts now have the functionality to handle standard events that InDesign emits. You can use the `}<a parentName="li" {...{
          "href": "../recipes/events/"
        }}>{`eventListener`}</a>{`object to catch such events. `}</li>
      <li parentName="ul">{`Arguments in UXP Scripts `}<br></br>
        <a parentName="li" {...{
          "href": "../recipes/arguments/"
        }}>{`Arguments`}</a>{` can now be passed to a UXP script, and can be used within the script. `}</li>
      <li parentName="ul">{`Setting script result `}<br></br>{`
UXP scripts now have a "result" associated with them. `}<a parentName="li" {...{
          "href": "../recipes/script-result/"
        }}>{`Set a result`}</a>{` for a script for debugging puposes as well as passed to another script for utilization.`}</li>
      <li parentName="ul">{`Menus `}<br></br>{`
UXP scripts now have APIs which can be used to add new menu items, remove existing menu items etc. `}<a parentName="li" {...{
          "href": "../recipes/menus/"
        }}>{`Read more`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      